import TopNLineMerger from "@/classes/lineMetricMerge/TopNLineMerger";

export default class TopNAxisLineMerger extends TopNLineMerger {
  protected get mergeKey(): string {
    return this.settings?.xAxis ?? "";
  }
}
